import { checkPath } from "./getConfig";

enum Environment {
  LOCALHOST = "localhost",
  TST = "tst",
  ACC = "acc",
  SANDBOX = "sandbox",
  POC = "poc",
  PROD = "prod",
}

const environmentRouteMap: Record<Environment, string> = {
  [Environment.LOCALHOST]: "http://localhost:4000",
  [Environment.TST]: "https://tst-nova.vaultn.com",
  [Environment.ACC]: "https://acc-nova.vaultn.com",
  [Environment.SANDBOX]: "https://sbx.vaultn.com",
  [Environment.POC]: "https://poc-nova.vaultn.com",
  [Environment.PROD]: "https://app.vaultn.com",
};

const launchDarklyClientIdMap: Record<Environment, string | undefined> = {
  [Environment.LOCALHOST]: process.env.VUE_APP_LAUNCH_DARKLY_CLIENT_ID_TST,
  [Environment.TST]: process.env.VUE_APP_LAUNCH_DARKLY_CLIENT_ID_TST,
  [Environment.ACC]: process.env.VUE_APP_LAUNCH_DARKLY_CLIENT_ID_ACC,
  [Environment.SANDBOX]: process.env.VUE_APP_LAUNCH_DARKLY_CLIENT_ID_SANDBOX,
  [Environment.POC]: process.env.VUE_APP_LAUNCH_DARKLY_CLIENT_ID_POC,
  [Environment.PROD]: process.env.VUE_APP_LAUNCH_DARKLY_CLIENT_ID_PRD,
};

// We only collect clarity data for ACC (testing) and PROD
const clarityProjectIdMap: Record<Environment, string | undefined> = {
  [Environment.LOCALHOST]: undefined,
  [Environment.TST]: undefined,
  [Environment.ACC]: process.env.VUE_APP_CLARITY_PROJECT_ID_ACC,
  [Environment.SANDBOX]: undefined,
  [Environment.POC]: undefined,
  [Environment.PROD]: process.env.VUE_APP_CLARITY_PROJECT_ID_PROD,
};

export function getVaultNovaEnvironmentPath() {
  const path = checkPath() as Environment;
  return environmentRouteMap[path] || environmentRouteMap[Environment.LOCALHOST];
}

export function getLaunchDarklyClientId(): string | undefined {
  const path = checkPath() as Environment;
  return launchDarklyClientIdMap[path] || launchDarklyClientIdMap[Environment.PROD];
}

export function getClarityProjectId(): string | undefined {
  const path = checkPath() as Environment;
  return clarityProjectIdMap[path] || undefined;
}